import { DropdownOption, DropdownOptionType } from '@ardoq/dropdown-menu';
import { IconName } from '@ardoq/icons';
import { dispatchAction } from '@ardoq/rxbeach';
import {
  type DropdownConfig,
  SettingsType,
  updateViewSettings,
} from '@ardoq/view-settings';
import {
  BubbleChartViewSettings,
  resolveIncludeAllDescendants,
} from '@ardoq/bubble-chart';
import { ViewIds } from '@ardoq/api-types';
import { t, type WithI18nLocale } from '@ardoq/i18n';

type IncludeAllDescendantsDropdownMenuArgs = Pick<
  BubbleChartViewSettings,
  'includeAllDescendants'
> &
  WithI18nLocale;

const includeAllDescendantsDropdownMenu = ({
  includeAllDescendants,
  i18nLocale,
}: IncludeAllDescendantsDropdownMenuArgs): DropdownConfig => {
  const resolvedIncludeAllDescendants = resolveIncludeAllDescendants(
    includeAllDescendants
  );
  return {
    id: 'includeAllDescendants',
    label: t(
      i18nLocale,
      'tabview:shared.includeDescendants.label',
      'Include descendants'
    ),
    iconName: IconName.BLUR_ON,
    type: SettingsType.DROPDOWN,
    options: [
      {
        type: DropdownOptionType.OPTION,
        label: t(
          i18nLocale,
          'tabview:shared.includeDescendants.hideAll',
          'Hide all descendants'
        ),
        isActive: resolvedIncludeAllDescendants === 'none',
        onClick: () =>
          dispatchAction(
            updateViewSettings({
              viewId: ViewIds.BUBBLE,
              settings: {
                includeAllDescendants: 'none',
              } satisfies Partial<BubbleChartViewSettings>,
              persistent: true,
            })
          ),
      } satisfies DropdownOption,
      {
        type: DropdownOptionType.OPTION,
        label: t(
          i18nLocale,
          'tabview:shared.includeDescendants.showDirect',
          'Show direct child components'
        ),
        isActive: resolvedIncludeAllDescendants === 'direct',
        onClick: () =>
          dispatchAction(
            updateViewSettings({
              viewId: ViewIds.BUBBLE,
              settings: {
                includeAllDescendants: 'direct',
              } satisfies Partial<BubbleChartViewSettings>,
              persistent: true,
            })
          ),
      } satisfies DropdownOption,
      {
        type: DropdownOptionType.OPTION,
        label: t(
          i18nLocale,
          'tabview:shared.includeDescendants.showAll',
          'Show all descendants'
        ),
        isActive: resolvedIncludeAllDescendants === 'all',
        onClick: () =>
          dispatchAction(
            updateViewSettings({
              viewId: ViewIds.BUBBLE,
              settings: {
                includeAllDescendants: 'all',
              } satisfies Partial<BubbleChartViewSettings>,
              persistent: true,
            })
          ),
      } satisfies DropdownOption,
    ],
  };
};
export { includeAllDescendantsDropdownMenu };
